module.exports = __webpack_public_path__ + "static/media/xindongchengbao@3x.b7237d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list/xindongchengbao@3x.png
// module id = 713
// module chunks = 0